module.exports = __webpack_public_path__ + "img/photo_2023-04-27 22.17.46.6fca2e0f.jpeg";